import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { Field } from '../../model/types.tsx';
import { getIssuesForRelatedFieldUrl } from '../../services/urls.tsx';
import {
	getSortedFields,
	getProjectKey,
	getVersionId,
	getVersionName,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';
import MoveVersion from './move-version/index.tsx';
import Content from './view.tsx';

const mapStateToProps = (state: State) => ({
	MoveVersion,
	fields: getSortedFields(state),
	versionName: getVersionName(state),
	renderVersionUrl: (field: Field) =>
		getIssuesForRelatedFieldUrl(getProjectKey(state), getVersionId(state), field),
});

export default connect(mapStateToProps, {})(Content);
